import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/cpcic-admin-release/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
/**
 * 用户信息
 * */
export default {
  namespaced: true,
  state: {
    // 用户信息
    info: {}
  },
  actions: {
    /**
     * @description 设置用户数据
     * @param {Object} state vuex state
     * @param {Object} dispatch vuex dispatch
     * @param {*} info info
     */
    set: function set(_ref, info) {
      var state = _ref.state,
        dispatch = _ref.dispatch;
      return new Promise(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                // store 赋值
                state.info = info;
                // 持久化
                _context.next = 3;
                return dispatch('admin/db/set', {
                  dbName: 'sys',
                  path: 'user.info',
                  value: info,
                  user: true
                }, {
                  root: true
                });
              case 3:
                // end
                resolve();
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 从数据库取用户数据
     * @param {Object} state vuex state
     * @param {Object} dispatch vuex dispatch
     */
    load: function load(_ref3) {
      var state = _ref3.state,
        dispatch = _ref3.dispatch;
      return new Promise(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dispatch('admin/db/get', {
                  dbName: 'sys',
                  path: 'user.info',
                  defaultValue: {},
                  user: true
                }, {
                  root: true
                });
              case 2:
                state.info = _context2.sent;
                // end
                resolve();
              case 4:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
  }
};